
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class ModeGrid extends Serenity.EntityGrid<ModeRow, any> {
        protected getColumnsKey() { return ModeColumns.columnsKey; }
        protected getDialogType() { return ModeDialog; }
        protected getIdProperty() { return ModeRow.idProperty; }
        protected getInsertPermission() { return ModeRow.insertPermission; }
        protected getLocalTextPrefix() { return ModeRow.localTextPrefix; }
        protected getService() { return ModeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}